import React, { useEffect, useState } from "react";
import Carusel from "../Components/Dashboard/Carusel";
import Topbar from "../Components/Structure/Topbar";
import { Grid } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import CallsArea from "../Components/Dashboard/CallsArea";
import { useSelector, useDispatch } from "react-redux";
import { redux_applicationSettings } from "../Redux/ApplicationSettings";
import {
  cancelCallApi,
  getActiveCallsApi,
  remakeCallApi,
  storeAppointmentApi,
  storeCallApi,
} from "../Apis/Endpoints/DashboardApi";
import AlertApiResult from "../Components/Structure/AlertApiResult";
import moment from "moment";
import Loading from "../Components/Structure/Loading";
import { useTranslation } from "react-i18next";

function Dashboard() {
  // 1) Data
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const ApplicationSettings = useSelector(
    (state) => state.ApplicationSettings.value
  );
  const LoginSettings = useSelector((state) => state.LoginSettings.value);
  const Account = useSelector((state) => state.Account.value);
  const [collapse, setcollapse] = useState(false);
  const [refreshCalls, setrefreshCalls] = useState(false);
  const [callsDataArray, setcallsDataArray] = useState([]);
  const [loading, setloading] = useState(false);
  const [callApiResultMessage, setcallApiResultMessage] = useState("");
  const [callApiResultStatus, setcallApiResultStatus] = useState("");
  const [callApiShowAlert, setcallApiShowAlert] = useState(false);
  const [firstLoad, setfirstLoad] = useState(true);
  const [callsFoundArray, setcallsFoundArray] = useState([]);
  const [distancesArray, setDistancesArray] = useState([]);
  const [googleApiKey, setgoogleApiKey] = useState("");
  const [Appointment_object, setAppointment_object] = useState({
    callTimeStamp: 0,
    callerPhone: Account.mobile,
    roadName: Account.address,
    municipality: Account.city,
    custComments: null,
    longitude: Account.geoX,
    latitude: Account.geoY,
    vehType: -1,
    taxisNo: 1,
    destination: null,
    customerName: null,
    dev: "WEB BUTTON",
    routeInfo: {
      distance: null,
      time: null,
    },
    callType: -1,
    paymentMethod: 0,
    emailToInform: null,
  });

  // 2) useEffects
  useEffect(() => {
    //on First Load
    const intervalId = setInterval(() => {
      getActiveCalls();
    }, ApplicationSettings.Refresh_Calls_Seconds * 1000);

    return () => {
      clearInterval(intervalId);
    };
  }, []);

  useEffect(() => {
    getActiveCalls();
    //console.log("callsDataArray : ", callsDataArray);

    return;
  }, [refreshCalls]);

  useEffect(() => {
    if (!firstLoad) {
      const foundCallsArray = callsDataArray.filter(
        (e) => e.info.callStatus === 10
      );
      //console.log("Dashboard Data Array (2) : ", foundCallsArray);
      setcallsFoundArray(foundCallsArray);
    } else setfirstLoad(false);

    return;
  }, [callsDataArray]);

  useEffect(() => {
    dispatch(
      redux_applicationSettings({
        ...ApplicationSettings,
        currentPage: "Dashboard",
      })
    );

    return;
  }, []);

  useEffect(() => {
    let key = "";
    if (ApplicationSettings.Use_Custom_Map_Key) {
      key = ApplicationSettings.Map_Key;
    } else {
      key = Account.google_key;
    }
    setgoogleApiKey(key);

    let url =
      "https://maps.googleapis.com/maps/api/js?key=" +
      key +
      "&libraries=places&callback=Function.prototype";

    let exist = isMyScriptLoaded(url);

    if (!exist) {
      var head = document.getElementsByTagName("head")[0];
      var script = document.createElement("script");
      script.type = "text/javascript";
      script.src =
        "https://maps.googleapis.com/maps/api/js?key=" +
        key +
        "&libraries=places&callback=Function.prototype";
      head.appendChild(script);
    }

    return;
  }, []);

  function isMyScriptLoaded(url) {
    var scripts = document.getElementsByTagName("script");
    for (var i = scripts.length; i--; ) {
      if (scripts[i].src == url) return true;
    }
    return false;
  }

  // 4) Dashboard Main Functions
  const getActiveCalls = async () => {
    // console.log("Get Calls list is called");
    let start = moment().subtract(1, "M").unix();
    let end = moment().unix();

    let calls = [];

    try {
      const response = await getActiveCallsApi(
        LoginSettings.web_server_url,
        start,
        end,
        Account.token
      );

      let responseObject = response.data.result;
      if (responseObject.resultCode === 0) {
        calls = response.data.response.calls;

        //console.log("RESPONSE CALLS :", calls);

        let x = Account.geoX;
        let y = Account.geoY;

        // console.log("Account.GeoX :", Account.geoX);

        const promises = [];
        calls.forEach((obj) => {
          if (obj.info.callStatus === 10 || obj.info.callStatus === 11) {
            //console.log("Foreach call Fetching :", obj);
            const { lastLatitude, lastLongitude } = obj;
            const promise = fetchDistanceMatrix(
              lastLatitude,
              lastLongitude,
              y,
              x,
              ""
            ).then(({ distance, duration }) => {
              obj.distance = distance;
              obj.duration = duration;
            });
            promises.push(promise);
          }
        });

        await Promise.all(promises);
        //console.log("Promises :", calls);
        setcallsDataArray(calls);
        setloading(false);
      } else {
        console.log("Error while trying to get calls");
      }
    } catch (error) {
      console.error("Error while fetching active calls:", error);

      const response = await getActiveCallsApi(
        LoginSettings.web_server_url,
        start,
        end,
        Account.token
      );
      let responseObject = response.data.result;
      if (responseObject.resultCode === 0) {
        calls = response.data.response.calls;
        setcallsDataArray(calls);
      }
    }
  };

  const fetchDistanceMatrix = (
    originLat,
    originLng,
    destLat,
    destLng,
    Location
  ) => {
    return new Promise((resolve, reject) => {
      const service = new window.google.maps.DistanceMatrixService();
      let origin = [];
      if (Location == "") {
        console.log("OriginLat :", originLat);
        console.log("OriginLng :", originLng);
        origin = new window.google.maps.LatLng(originLat, originLng);
      } else {
        origin = Location;
      }

      const destination = new window.google.maps.LatLng(destLat, destLng);

      //console.log("Google Api is called now...");

      // console.log("destLat :", destLat);
      // console.log("destLng :", destLng);
      // console.log("Location :", Location);
      console.log("origin :", origin);

      service.getDistanceMatrix(
        {
          origins: [origin],
          destinations: [destination],
          travelMode: "DRIVING",
        },
        (response, status) => {
          if (status === "OK" && response.rows.length > 0) {
            //console.log("response DM : ", response);
            let distance = "undefined";
            let duration = "undefined";
            try {
              distance = response.rows[0].elements[0].distance.text;
              duration = response.rows[0].elements[0].duration.text;
            } catch (error) {
              console.log("Error on fetch :", error);
            }

            resolve({ distance, duration });
          } else {
            reject(new Error("Unable to fetch distance matrix"));
          }
        }
      );
    });
  };

  const storeCall = async (callObject) => {
    console.log("Store Call Called");
    storeCallApi(LoginSettings.web_server_url, callObject, Account.token)
      .then((response) => {
        if (response.status === 200) {
          console.log("Response send ok with : ", response.data);
          setcallApiResultStatus("Success");
          setcallApiResultMessage("Call has been stored.");
          setcallApiShowAlert(true);
          setTimeout(getActiveCalls, 1000);
        }
      })
      .catch((error) => {
        if (error.response.status === 401) {
          let er = error.response.data.error_description;

          setcallApiResultStatus("Error");
          setcallApiResultMessage(er);
          setcallApiShowAlert(true);
        } else {
          // handle other errors

          setcallApiResultStatus("Error");
          setcallApiResultMessage("Something went wrong.");
          setcallApiShowAlert(true);
        }
      })
      .finally(() => {
        setloading(false);
        window.scrollTo(0, 0);
      });
  };

  const callNow = async (
    destination,
    customerName,
    comment,
    paymentType,
    callType
  ) => {
    setloading(true);

    // Extract full Name

    let fullName = "";
    if (customerName === "") {
      if (Account.fname.length > 0 || Account.sname.length > 0) {
        fullName = Account.fname + " " + Account.sname;
      }
    } else {
      fullName = customerName;
    }

    //Object
    let New_Call_Request = {
      callerPhone: Account.mobile,
      roadName: Account.address,
      municipality: Account.city,
      comments: comment,
      longitude: Account.geoX,
      latitude: Account.geoY,
      taxisNo: 1,
      destination: destination,
      customerName: fullName,
      dev: "WEB BUTTON",
      vehType: ApplicationSettings.CarTypesArray[0].code,
      callType: callType,
    };

    if (paymentType) {
      New_Call_Request.vehType =
        New_Call_Request.vehType + ApplicationSettings.Code_for_POS;
      New_Call_Request.paymentMethod = 2;
      New_Call_Request.isPOS = true;
    }

    console.log("New_Call_Request :", New_Call_Request);
    storeCall(New_Call_Request);
  };

  const callLater = async (callObject, callType) => {
    //Extract full Name

    console.log("1) Appointment called with : ", { callObject, callType });

    let fullName = "";
    if (callObject.customerName === "") {
      if (Account.fname.length > 0 || Account.sname.length > 0) {
        fullName = Account.fname + " " + Account.sname;
      }
    } else {
      fullName = callObject.customerName;
    }

    //Timestamp of date
    let date =
      moment(callObject.date).format("MM/DD/YYYY") + " " + callObject.time;
    date = moment(date).unix();

    //Pediko kathisma in comment
    let newComment = "";
    if (
      callObject.pedikoKathisma.length > 0 &&
      callObject.pedikoKathisma != ""
    ) {
      newComment = "Παδικό κάθισμα:" + callObject.pedikoKathisma + ", ";
    }
    newComment = newComment + callObject.comment;

    // Send Email to User?

    //console.log("APOINTMENT STORED : ", New_Call_Request);

    // 1) Check Call Objects destination. if it is button then filter the name and take the lat lng, if not geocode.
    try {
      let btns = ApplicationSettings.ButtonsArray;
      let extrbtns = ApplicationSettings.Extra_Destinations_Array;
      let arrivalTimeObj = {};
      let x = 0;
      let y = 0;

      const result1 = btns.filter((obj) => obj.name === callObject.destination);
      const result2 = extrbtns.filter(
        (obj) => obj.name === callObject.destination
      );
      let promise;

      console.log("Result1 :", result1);
      console.log("Result2 :", result2);

      //new solution

      if (result1.length > 0) {
        x = result1[0].lat;
        y = result1[0].lng;
      } else if (result2.length > 0) {
        x = result2[0].lat;
        y = result2[0].lng;
      }

      if (x !== 0 && y !== 0) {
        console.log("2) Distance Matrix called");
        promise = fetchDistanceMatrix(x, y, Account.geoY, Account.geoX, "")
          .then(({ distance, duration }) => {
            console.log(" 3) DM Result : ", { distance, duration });
            arrivalTimeObj.distance = distance;
            arrivalTimeObj.duration = duration;
          })
          .catch((e) => {
            console.log("Error:", e);
          });
      } else {
        console.log("4) Distance Matrix called");
        promise = fetchDistanceMatrix(
          x,
          y,
          Account.geoY,
          Account.geoX,
          callObject.destination
        )
          .then(({ distance, duration }) => {
            console.log(" 3) DM Result : ", { distance, duration });

            arrivalTimeObj.distance = distance;
            arrivalTimeObj.duration = duration;
          })
          .catch((e) => {
            console.log("Error:", e);
          });
      }

      await Promise.all([promise]);

      //console.log("obj : ", arrivalTimeObj);
      //Object
      let New_Call_Request = {
        callTimeStamp: date,
        callerPhone: Account.mobile,
        roadName: Account.address,
        municipality: Account.city,
        custComments: newComment,
        longitude: Account.geoX,
        latitude: Account.geoY,
        vehType: callObject.vehicleType,
        taxisNo: 1,
        destination: callObject.destination,
        customerName: fullName,
        dev: "WEB BUTTON",
        routeInfo: {
          distance: arrivalTimeObj.distance,
          time: arrivalTimeObj.duration,
        },
        callType: callType,
      };

      if (callObject.paymentMethod !== undefined) {
        New_Call_Request.paymentMethod = 2;
        New_Call_Request.isPOS = true;
      }

      if (callObject.sendEmail) {
        New_Call_Request.emailToInform = ApplicationSettings.Email_To_Inform;
      }

      console.log("New_Call_Request :", New_Call_Request);
      storeAppointment(New_Call_Request);
    } catch (error) {
      console.log("Error on Appointments :", error);
    }
  };

  const storeAppointment = async (callObject) => {
    //console.log("Store Appointment Called");

    storeAppointmentApi(LoginSettings.web_server_url, callObject, Account.token)
      .then((response) => {
        if (response.status === 200) {
          //console.log("Response send ok with : ", response.data);
          setcallApiResultStatus("Success");
          setcallApiResultMessage("Appointment has been stored.");
          setcallApiShowAlert(true);

          getActiveCalls();
        } else {
          console.log("ERROR OCCUURED");
        }
      })
      .catch((error) => {
        if (error.response.status === 401) {
          let er = error.response.data.error_description;

          setcallApiResultStatus("Error");
          setcallApiResultMessage(er);
          setcallApiShowAlert(true);
        } else {
          // handle other errors

          setcallApiResultStatus("Error");
          setcallApiResultMessage("Something went wrong.");
          setcallApiShowAlert(true);
        }
      })
      .finally(() => {
        setloading(false);
        window.scrollTo(0, 0);
      });
  };

  const remakeCall = async (callObject) => {
    // console.log("Remake Call Called with : ", callObject);

    let request_object = {
      callerPhone: "000",
      roadName: callObject.pickupAddress,
      //municipality: "",
      longitude: callObject.pickupLng,
      latitude: callObject.pickupLat,
      taxisNo: 1,
      destination: callObject.destination,
      customerName: callObject.customerName,
      dev: "WEB BUTTON",
      callId: callObject.callID,
    };

    remakeCallApi(LoginSettings.web_server_url, request_object, Account.token)
      .then((response) => {
        if (response.status === 200) {
          // console.log("Response send ok with : ", response.data);
          setcallApiResultStatus("Success");
          setcallApiResultMessage("Call has been stored.");
          setcallApiShowAlert(true);
          setTimeout(getActiveCalls, 1000);
        } else {
          console.log("ERROR OCCUURED");
        }
      })
      .catch((error) => {
        if (error.response.status === 401) {
          let er = error.response.data.error_description;

          setcallApiResultStatus("Error");
          setcallApiResultMessage(er);
          setcallApiShowAlert(true);
        } else {
          // handle other errors

          setcallApiResultStatus("Error");
          setcallApiResultMessage("Something went wrong.");
          setcallApiShowAlert(true);
        }
      })
      .finally(() => {
        setloading(false);
      });
  };

  const cancelCall = async (callObject) => {
    //console.log("Cancel Call Called with : ", callObject);

    let request_object = {
      callId: callObject.info.callID,
      driverID: callObject.info.driverId,
    };

    cancelCallApi(LoginSettings.web_server_url, request_object, Account.token)
      .then((response) => {
        if (response.status === 200) {
          //("Response send ok with : ", response.data);
          setcallApiResultStatus("Success");
          setcallApiResultMessage("Call has been canceled.");
          setcallApiShowAlert(true);
          setTimeout(getActiveCalls, 1000);
        } else {
          console.log("ERROR OCCUURED");
        }
      })
      .catch((error) => {})
      .finally(() => {
        setloading(false);
      });
  };

  return (
    <>
      {callApiShowAlert && (
        <AlertApiResult
          message={callApiResultMessage}
          status={callApiResultStatus}
          setClose={setcallApiShowAlert}
        />
      )}
      <Topbar
        collapse={collapse}
        setcollapse={setcollapse}
        setrefreshCalls={setrefreshCalls}
        refreshCalls={refreshCalls}
        loading={loading}
        setLoading={setloading}
        page="Dashboard"
      />

      <Carusel
        callNow={callNow}
        callLater={callLater}
        key={googleApiKey}
        Appointment_object={Appointment_object}
        setAppointment_object={setAppointment_object}
      />
      {loading ? (
        <Loading />
      ) : (
        <CallsArea
          collapse={collapse}
          setcollapse={setcollapse}
          data={callsDataArray}
          remakeCall={remakeCall}
          cancelCall={cancelCall}
          distanceArray={distancesArray}
        />
      )}
    </>
  );
}

export default Dashboard;
